import type { TOC } from '@ember/component/template-only';
import type { Dayjs } from 'dayjs';
import dayjsFormat from 'lumen/helpers/dayjs-format';

interface SettingsHotelAccessFormsAccessRightsDateSignature {
  Args: {
    cellData: Dayjs;
    row: {
      isLocked: boolean;
    };
  };
}

const SettingsHotelAccessFormsAccessRightsDate = <template>
  <p
    class="text-200--regular {{if @row.isLocked 'row-text--disabled'}}"
  >{{dayjsFormat @cellData format="L"}}</p>
</template> satisfies TOC<SettingsHotelAccessFormsAccessRightsDateSignature>;

export default SettingsHotelAccessFormsAccessRightsDate;
